<template>
	<layout-admin>
		<ui-alert
			v-if="success"
			type="success"
			:message="success == true ? 'Your inputs have been saved!' : success"
		/>
		<ui-alert v-if="error" type="error" :message="error" />

		<div class="pb-8 px-6 fixed bottom-0 flex right-0 z-10">
			<ui-button
				class="ml-auto text-lg shadow-xl"
				label="Save"
				v-on:click="submitForm()"
				:disabled="submitButtonDisabled"
			/>
		</div>

		<admin-user-fields :user="form" :form="form" :can-advanced="true" />
		<user-edit-base-data
			:user="form"
			:form="form"
			:can-edit-company-type="true"
		/>
		<user-edit-contact-details :user="form" :form="form" />
		<user-edit-bank-account-details :user="form" :form="form" />
		<user-edit-loading-details :user="form" :form="form" />
		<user-edit-notifications :user="form" :form="form" />
		<div class="p-6">
			<h1 class="text-2xl font-semibold text-gray-900 mb-6">
				{{ __("Referrals") }}
			</h1>
			<p class="mb-2">
				<strong>Referral-ID:</strong> {{ initialData.referral_id }}
			</p>
			<h2 class="text-1xl font-semibold text-gray-900 mb-6">
				Geworbene Freunde
			</h2>
			<table class="min-w-full divide-y divide-gray-200 mb-20">
				<thead class="bg-gray-50">
					<tr>
						<th>UserId</th>
						<th>Firma</th>
					</tr>
				</thead>
				<tbody class="bg-white divide-y divide-gray-200">
					<tr
						scope="col"
						v-for="referral in referrals"
						:key="referral.id"
						class="px-4 py-4 whitespace-nowrap text-center"
					>
						<td>{{ referral.id }}</td>
						<td v-if="referral.company_name">{{ referral.company_name }}</td>
						<td v-else><em>Nicht hinterlegt</em></td>
					</tr>
				</tbody>
			</table>
		</div>
	</layout-admin>
</template>

<script>
import Vue from "vue";
import axios from "axios";

export default {
	props: {
		initialData: {
			type: Object,
			required: true,
		},
		success: {
			default: false,
		},
		error: {
			type: String,
			required: false,
		},
	},
	data() {
		return {
			form: Vue.observable(
				this.$inertia.form(
					Object.assign(this.initialData, {
						current_password: null,
						new_password: null,
						new_password_confirmation: null,
						file: null,
						label_id: null,
					})
				)
			),
			submitButtonDisabled: false,
			referrals: [],
		};
	},
	created() {
		console.log(this.initialData);
		axios.get(`/api/referrals/${this.initialData.id}`).then((response) => {
			this.referrals = response.data;
		});
	},
	methods: {
		async submitForm() {
			let endpoint = this.$page.url,
				method = "patch",
				that = this;

			this.submitButtonDisabled = true;
			this.form.submit(method, endpoint, {
				preserveState: true,
				onSuccess(p) {
					console.log("SUCCESS SUBMISSION, got: ", p);
				},
				onFinish(e) {
					that.submitButtonDisabled = false;
					console.log("submit FINISH", method, endpoint, "got:", e);
				},
			});
		},
	},
};
</script>
